export enum GallerySectionItem {
  GALLERY = 'gallery',
  BLUEPRINTS = 'blueprints',
  VIRTUAL_TOUR = 'virtual-tour',
  VIDEO = 'video',
  MAP = 'map',
  STREET_VIEW = 'street-view',
}
